module.exports = __webpack_public_path__ + "img/liangtang-back-one@3x.ffad759e.png";